import { getSessionToken } from 'api/apiConfig'
import axios from 'axios'
import { createFormData, createJsonData } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import {
  APIURL,
  config,
  ICAS_AUTHORIZATION_URL,
  ICAS_API_KEY,
  ICAS_API_URL,
} from './_utils'

export const auth = {
  getToken: () =>
    axios.post(
      ICAS_AUTHORIZATION_URL,
      null,
      config({ accessToken: getSessionToken(), apiKey: ICAS_API_KEY })
    ),
  getICASRedirectUrl: (data) =>
    axios.post(
      `${APIURL}/v2/icas/request-redirect/`,
      data,
      config({ apiKey: ICAS_API_KEY, contentType: HTTP.ContentTypes.JSON })
    ),

  confirmICASAuthCode: (formData) =>
    axios.post(`${APIURL}/v2/icas/confirm-code/`, formData, config()),

  getProfileData: () =>
    axios.get(
      `${ICAS_API_URL}/v1/profiles/profile/me/`,
      config({ apiKey: ICAS_API_KEY })
    ),

  updateProfileData: (formData) =>
    axios.patch(
      `${ICAS_API_URL}/v1/profiles/profile/me/`,
      formData,
      config({ apiKey: ICAS_API_KEY })
    ),

  changePassword: (formData) =>
    axios.post(
      `${ICAS_API_URL}/v1/profiles/change-password/`,
      createFormData(formData),
      config({ apiKey: ICAS_API_KEY })
    ),
  getBusinessData: (businessSlug) =>
    axios.get(
      `${ICAS_API_URL}/v2/businesses/${businessSlug}/`,
      config({ apiKey: ICAS_API_KEY })
    ),
  updateBusinessData: (businessSlug, formData, options = {}) =>
    axios.patch(
      `${ICAS_API_URL}/v2/businesses/${businessSlug}/`,
      createFormData(formData, options),
      config({ apiKey: ICAS_API_KEY })
    ),

  getFormzBusinessList: () =>
    axios.get(
      `${ICAS_API_URL}/v2/businesses/`,
      config({ apiKey: ICAS_API_KEY })
    ),

  // workspace teams
  getWorkspaceTeams: (params) =>
    axios.get(
      `${ICAS_API_URL}/v2/profile-teams/`,
      config({ apiKey: ICAS_API_KEY, params })
    ),

  // plans

  purchasePlan: (business, formObj) =>
    axios.post(
      `${ICAS_API_URL}/v2/businesses/${business}/plans/`,
      createJsonData(formObj),
      config({ apiKey: ICAS_API_KEY, contentType: HTTP.ContentTypes.JSON })
    ),

  // slack access
  getSlackAccesses: (params = {}) =>
    axios.get(
      `${ICAS_API_URL}/v2/oauth2/slack/`,
      config({ apiKey: ICAS_API_KEY, params })
    ),
}
